module.exports = __webpack_public_path__ + "img/defaultProductIco.a8574a3a.png";